import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {getAccountPagoMovil} from "../../services/wallet/accounts";

const useGetAccountPagoMovil = () => {
  const [result, setResult] = useState();
  const {data, isError, isPending, isSuccess, isStale, refetch, error} = useQuery({
    queryKey: ["userMobileAccount"],
    queryFn: getAccountPagoMovil,
    staleTime: 5 * (60 * 1000), // 5 mins,
  });

  useEffect(() => {
    if (isStale) {
      refetch();
    }
  }, [isStale]);

  useEffect(() => {
    if (data) {
      setResult(data?.data.data);
    }
  }, [data]);

  return {data: result, isError, isPending, refetch, isSuccess, error};
};

export default useGetAccountPagoMovil;
